export default __webpack_public_path__ + "static/media/logo25.a18f9c25.png";